export function getConsentInfo(getCookieFunction) {
    const { groups, datestamp } = parseOptanonCookie(getCookieFunction('OptanonConsent'));
    const parsedDatestamp = parseDate(datestamp);
    if (groups && parsedDatestamp)
        return { groups, datestamp: parsedDatestamp };
    return undefined;
}
function parseOptanonCookie(cookie) {
    return ((cookie === null || cookie === void 0 ? void 0 : cookie.split('&').reduce((acc, val) => {
        const [key, value] = val.split('=');
        acc[key] = decodeURIComponent(value);
        return acc;
    }, {})) || {});
}
const parseDate = (date) => {
    if (!date)
        return undefined;
    const dateStampWithoutPlus = date.replace(/\+/g, ' ');
    const parsedDate = new Date(dateStampWithoutPlus).getTime();
    if (Number.isFinite(parsedDate)) {
        return parsedDate;
    }
    return undefined;
};
//# sourceMappingURL=consent-info.js.map